var m = require('mithril');
var enumerationModal = require('./enumerationModal');
var enumerationClearModal = require('./enumerationClearModal');
var hasEnumerationOptions = require('./hasEnumerationOptions');

var enumerationEditor = {};



enumerationEditor.view = function(vnode) {
  var ctrl = this;
  var pointHasEnumeration = hasEnumerationOptions(vnode.attrs.point().enumeration);
  return m('div', [
    m('div.bb.b--mid-gray.bw1.w-100', 'Enumeration'),
    m('div.flex.justify-between.items-center',[
      m('div.flex.mt1', [
        m('div.f4.ba.bw1.ph3.pv2.tc.v-btm', {
          onclick: function () {
            enumerationModal.editDialogue(vnode.attrs.point, {submitCallback: ctrl.init});
          }
        },[
          m('div.flex.items-center.justify-center.blue', [
            pointHasEnumeration ?
              [
                'Edit Enumeration',
                m('i.ion-ios-compose.ml2') 
              ]
            :
              [
                'Add Enumeration',
                m('i.ion-plus.ml2')
              ]
          ])
        ]),
      ]),
      pointHasEnumeration ?
        m('div.flex.mt1', [
          m('div.f4.ba.bw1.ph3.pv2.tc.v-btm', {
            onclick: function () {
              enumerationClearModal.editDialogue(vnode.attrs.point, {submitCallback: ctrl.init});
            }
          },[
            m('div.flex.items-center.justify-center.red', [
              'Clear Enumeration',
              m('i.ion-ios-trash.ml2') 
            ])
          ]),
        ])
      : 
        '',
    ]),
   
  ])
}

module.exports = enumerationEditor;
